import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Box } from '@mui/material';
import { Button } from '@mui/material';
import TripActivitiesMapMessages from '../TripActivitiesMapMessages';
import React, { useState } from 'react';
import { Paper } from '@mui/material';
// import TripLegMonitoringSection from '../TripLegsListTable';

import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const PREFIX = 'Exception';

const classes = {
  containerDrop: `${PREFIX}-container`,
};

const CustomInputLabel1 = styled(Paper)(({ theme }) => ({
  [`&.${classes.containerDrop}`]: {
    display: 'flex',
    width: '100%',
    justifyContent: 'stretch',
  },
}));

const ButtonItem = styled(Box)(() => ({
  display: 'centre',
}));

const Main = styled.div`
  position: absolute;
  height: calc(100% - 64px);
  width: calc(100% - 248px);
  top: 64px;
  right: 0px;
  bottom: 0px;
  left: 248px;
  overflow: hidden;
`;
const Large1200px1535px = styled.div`
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background-color: var(--light-primary-contrast);
  width: 1440px;
  z-index: 0;
`;
const GreyBandChild = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0%;
  right: 0%;
  bottom: 0%;
  left: 0%;
  background-color: var(--light-secondary-shades-4p);
  opacity: 0.75;
`;
const GreyBand = styled.div`
  position: absolute;
  margin: 0 !important;
  width: 100%;
  top: 0px;
  right: 1px;
  left: -1px;
  background-color: var(--light-primary-contrast);
  height: 220px;
  opacity: 0.6;
  z-index: 0;
`;
const TitleBreadcrumbs = styled.div`
  flex: 1;
  z-index: 0;
`;
const MaskedIcon = styled.img`
  position: relative;
  width: 20px;
  height: 20px;
`;
const Button11 = styled.div`
  position: relative;
  letter-spacing: 0.4px;
  line-height: 24px;
  font-weight: 600;
  display: none;
`;
const MaskedIcon1 = styled.img`
  position: relative;
  width: 16px;
  height: 20px;
  display: none;
`;
const Base = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-5xs) var(--padding-5xs) var(--padding-5xs)
    var(--padding-xs);
  gap: var(--gap-5xs);
`;
const Buttoncontained = styled.div`
  top: 3px;
  left: 0px;
  margin-right: 15px;
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Monitoring = styled.span`
  letter-spacing: 0.5px;
  line-height: 48px;
`;
const Span = styled.span`
  font-size: var(--typography-h2-size);
  letter-spacing: 0.25px;
  line-height: 40px;
`;
const Monitoring5 = styled.b`
  position: absolute;
  top: 0px;
  left: 0px;
  display: inline-block;
  width: 883px;
  height: 48px;
`;
const Text1 = styled.div`
  position: relative;
  letter-spacing: 0.14px;
  line-height: 24px;
  font-weight: 600;
`;
const Badge = styled.div`
  position: absolute;
  top: 4px;
  left: 199px;
  border-radius: var(--br-45xl);
  background-color: var(--light-primary-main);
  width: 20px;
  height: 20px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px var(--padding-6xs-5);
  box-sizing: border-box;
  font-size: var(--components-helper-text-size);
  color: var(--light-primary-contrast);
  font-family: var(--typography-body-1);
`;
const Monitoring5Parent = styled.div`
  position: absolute;
  top: 0px;
  left: 52px;
  width: 883px;
  height: 48px;
  font-size: 36px;
  color: var(--light-text-primary);
  font-family: var(--typography-h3);
`;
const ButtoncontainedParent = styled.div`
  position: absolute;
  margin: 0 !important;
  top: 0px;
  left: 0px;
  width: 935px;
  height: 48px;
  z-index: 1;
`;
const LeftSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  gap: var(--gap-5xl);
`;
const Spacer = styled.div`
  position: absolute;
  height: 100%;
  top: 0px;
  bottom: 0px;
  left: calc(50% - 4px);
  width: 8px;
`;
const Frame = styled.div`
  flex: 1;
  position: relative;
  background-color: var(--color-gray-200);
  width: 8px;
`;
const Spacerhorizontal = styled.div`
  height: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const MaskedIcon2 = styled.img`
  position: relative;
  width: 18px;
  height: 22px;
  display: none;
`;
const Button1 = styled.div`
  position: relative;
  letter-spacing: 0.46px;
  line-height: 24px;
  font-weight: 600;
`;
const CallIcon = styled.img`
  position: relative;
  width: 24px;
  height: 24px;
`;
const Base1 = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-xs) var(--padding-13xl);
  gap: var(--gap-5xs);
`;
const Buttonoutlined = styled.div`
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  border: 1px solid var(--light-primary-shades-50p);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: var(--components-button-large-size);
  color: var(--light-primary-main);
`;
const HeaderArea = styled.div`
  align-self: stretch;
  flex: 1;
  border-radius: var(--br-10xs);
  border-bottom: 1px solid var(--light-other-divider);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-5xl) 0px;
`;
const PageHeaderWRightActions = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-5xl) var(--padding-5xl) 0px;
  z-index: 0;
`;
const VectorIcon = styled.img`
  position: relative;
  width: 15.47px;
  height: 14.73px;
`;
const Wrapper1 = styled.div`
  width: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px var(--padding-5xs);
  box-sizing: border-box;
`;
const EmmaTaylor = styled.b`
  position: relative;
  letter-spacing: 0.25px;
  line-height: 40px;
`;
const WrapperParent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap-5xs);
`;
const Text11 = styled.div`
  position: relative;
  font-size: var(--typography-body-1-size);
  letter-spacing: 0.15px;
  line-height: 150%;
  font-family: var(--typography-body-1);
  display: inline-block;
  width: 480px;
  height: 26.28px;
  flex-shrink: 0;
`;
const TitleBreadcrumbs1 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: var(--gap-base);
`;
const HeaderArea1 = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const ChevronleftoutlinedIcon = styled.img`
  position: relative;
  width: 24px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
`;
const BaseStepElements = styled.div`
  width: 7px;
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Back = styled.div`
  position: relative;
  letter-spacing: 0.25px;
  line-height: 32px;
`;
const BaseStepElementsParent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: var(--gap-5xs);
`;
const Leg1Of = styled.span``;
const Active = styled.span`
  color: var(--light-success-main);
`;
const Base2 = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-xs) var(--padding-xl) var(--padding-xs)
    var(--padding-5xl);
  gap: var(--gap-5xs);
`;
const Buttoncontained11 = styled.div`
  width: 100%;
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Buttoncontained1 = styled.div`
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const Buttonoutlined1 = styled.div`
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  border: 1px solid var(--light-primary-shades-50p);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--light-primary-main);
`;
const Container = styled.div`
  border-radius: var(--br-29xl);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: var(--padding-xs);
`;
const Iconbutton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const ButtoncontainedGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-base);
  font-size: var(--components-button-large-size);
`;
const InstanceParent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  font-size: var(--typography-h4-size);
  font-family: var(--typography-body-1);
`;
const HeaderAreaParent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const PageHeaderWRightActions1 = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-5xl) var(--padding-5xl) var(--padding-base);
  z-index: 1;
  font-size: var(--typography-h2-size);
  color: var(--light-text-primary);
  font-family: var(--typography-h3);
`;
const StaroutlinefilledIcon = styled.img`
  position: relative;
  width: 20px;
  height: 20px;
  overflow: hidden;
  flex-shrink: 0;
`;
const Icon = styled.div`
  margin: 0 !important;
  position: absolute;
  top: 96.75px;
  left: 258px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 2;
`;
const PlaceholderimageIcon = styled.img`
  align-self: stretch;
  flex: 1;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
`;
const Cardelementscardmedia = styled.div`
  align-self: stretch;
  height: 100px;
  display: none;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Status1 = styled.div`
  position: relative;
  letter-spacing: 0.4px;
  line-height: 166%;
`;
const InTransit = styled.div`
  position: relative;
  font-size: var(--typography-h4-size);
  letter-spacing: 0.25px;
  line-height: 32px;
  color: var(--light-success-main);
`;
const Content1 = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Span1 = styled.span`
  letter-spacing: 0.25px;
  line-height: 32px;
`;
const Am1 = styled.span`
  font-size: var(--components-button-large-size);
  letter-spacing: 1px;
  line-height: 24px;
  text-transform: uppercase;
  font-weight: 600;
`;
const Am = styled.div`
  position: relative;
  color: var(--light-text-primary);
  font-size: var(--typography-h4-size);
`;
const Content2 = styled.div`
  width: 91px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Am2 = styled.div`
  position: relative;
  font-size: var(--typography-h4-size);
`;
const Content3 = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  color: var(--light-text-primary);
`;
const Subheader = styled.div`
  flex: 1;
  position: relative;
  font-size: var(--typography-subtitle-2-size);
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--light-text-secondary);
  display: none;
`;
const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Cardelementscardheader = styled.div`
  align-self: stretch;
  border-radius: var(--br-9xs) var(--br-9xs) 0px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: var(--padding-5xl) var(--padding-13xl) var(--padding-base);
`;
const Dividerhorizontal = styled.div`
  align-self: stretch;
  position: relative;
  border: 1px solid var(--light-other-divider);
  box-sizing: border-box;
  height: 1px;
  display: none;
`;
const Created = styled.div`
  position: relative;
  letter-spacing: 0.1px;
  line-height: 157%;
  font-weight: 600;
`;
const Details = styled.div`
  position: relative;
  font-size: var(--components-helper-text-size);
  letter-spacing: 0.4px;
  line-height: 166%;
  color: var(--molina-main);
`;
const Step = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--gap-5xs);
`;
const Connector = styled.div`
  position: absolute;
  height: 100%;
  top: 0%;
  bottom: 0%;
  left: calc(50% - 1px);
  background-color: var(--light-success-main);
  width: 1px;
`;
const Mask = styled.div`
  flex: 1;
  position: relative;
  width: 24px;
`;
const Connector2 = styled.div`
  position: absolute;
  height: 100%;
  top: 0%;
  bottom: 0%;
  left: calc(50% - 1px);
  background: linear-gradient(180deg, #00930f, #c8c8c8 55.73%);
  width: 1px;
`;
const MaskChild = styled.div`
  position: absolute;
  top: 11px;
  left: 0px;
  border-radius: 50%;
  background-color: var(--light-success-main);
  width: 24px;
  height: 24px;
`;
const Mask2 = styled.div`
  position: relative;
  width: 24px;
  height: 46px;
`;
const Value = styled.div`
  align-self: stretch;
  flex: 1;
  position: relative;
  letter-spacing: 0.4px;
  line-height: 166%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const BaseStepElements4 = styled.div`
  border-radius: var(--br-45xl);
  background-color: var(--light-text-disabled);
  width: 24px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px var(--padding-6xs);
  box-sizing: border-box;
`;
const Onsite = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
`;
const Details2 = styled.div`
  position: relative;
  font-size: var(--components-helper-text-size);
  letter-spacing: 0.4px;
  line-height: 166%;
  color: var(--molina-main);
  display: none;
`;
const Content7 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  font-size: var(--typography-subtitle-2-size);
  color: var(--light-text-secondary);
`;
const Step3 = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--gap-5xs);
  text-align: center;
  font-size: var(--components-helper-text-size);
  color: var(--light-primary-contrast);
`;
const Connector3 = styled.div`
  position: absolute;
  height: 100%;
  top: 0%;
  bottom: 0%;
  left: calc(50% - 1px);
  background-color: var(--common-grey-400);
  width: 1px;
`;
const Mask3 = styled.div`
  position: relative;
  width: 24px;
  height: 30px;
`;
const Optional = styled.div`
  position: relative;
  font-size: var(--components-helper-text-size);
  letter-spacing: 0.4px;
  line-height: 166%;
  color: var(--light-text-primary);
  display: none;
`;
const Optional1 = styled.div`
  position: relative;
  font-size: var(--components-helper-text-size);
  letter-spacing: 0.4px;
  line-height: 166%;
  color: var(--light-text-primary);
  display: none;
  width: 47px;
`;
const Stepper = styled.div`
  height: 423px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px var(--padding-base);
  box-sizing: border-box;
`;
const Ambd2d = styled.p`
  margin: 0;
`;
const AmAmbd2d = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--light-text-primary);
  text-align: left;
  display: inline-block;
  width: 120px;
`;
const EmmaTaylorParent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
`;
const TypographyParent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: var(--padding-11xs) 0px;
`;
const Step6 = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 213px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-xs);
`;
const PmMikeDriverContainer = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--light-text-primary);
  text-align: left;
  display: inline-block;
  width: 189.9px;
`;
const Step7 = styled.div`
  position: absolute;
  top: 91px;
  left: 0px;
  width: 213px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-xs);
`;
const HarrietLaneSouthBoulderContainer = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  text-align: left;
  display: inline-block;
  width: 213px;
`;
const AmParent = styled.div`
  width: 213px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
`;
const Step8 = styled.div`
  position: absolute;
  top: 308px;
  left: 0px;
  width: 213px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-xs);
  color: var(--light-text-primary);
`;
const DriverUpdatedTrip = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  text-align: left;
  display: inline-block;
  width: 208.22px;
`;
const Step9 = styled.div`
  position: absolute;
  top: 187px;
  left: 0px;
  width: 213px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-xs);
  color: var(--light-text-primary);
`;
const EmmaTaylor2 = styled.div`
  position: relative;
  letter-spacing: 0.1px;
  line-height: 157%;
  font-weight: 600;
  display: none;
`;
const HarrietLaneSouthBoulderContainer1 = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--light-text-primary);
  text-align: left;
  display: inline-block;
  width: 145px;
`;
const Step10 = styled.div`
  position: absolute;
  top: 384px;
  left: 0px;
  width: 213px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
`;
const StepParent = styled.div`
  flex: 1;
  position: relative;
  height: 400px;
  text-align: right;
  color: var(--molina-main);
`;
const StepperParent = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-base);
`;
const Cardelementscardcontent = styled.div`
  align-self: stretch;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-13xl);
  font-size: var(--typography-subtitle-2-size);
  color: var(--light-text-primary);
`;
const Card = styled.div`
  align-self: stretch;
  border-radius: var(--br-10xs);
  background-color: #f6fafc;
  height: 539px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px var(--padding-5xl);
  box-sizing: border-box;
  color: var(--text-normal);
`;
const Label = styled.div`
  position: relative;
  letter-spacing: 0.15px;
  line-height: 12px;
`;
const Adornmentstart = styled.div`
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const AdornStartContainer = styled.div`
  height: 1px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  z-index: 0;
`;
const Avatar = styled.div`
  border-radius: var(--br-45xl);
  background-color: var(--common-grey-400);
  width: 24px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 0;
`;
const Badge1 = styled.div`
  position: absolute;
  height: 50%;
  width: 50%;
  top: 25%;
  right: 25%;
  bottom: 25%;
  left: 25%;
  border-radius: var(--br-5xs);
  background-color: var(--light-success-main);
  overflow: hidden;
`;
const Border = styled.div`
  position: absolute;
  margin: 0 !important;
  right: -2px;
  bottom: -2px;
  border-radius: var(--br-45xl);
  background-color: var(--light-primary-contrast);
  width: 8px;
  height: 8px;
  display: none;
  z-index: 1;
`;
const AvatarMessagesfalse24pxc = styled.div`
  background-color: var(--color-gray-200);
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
const Chip = styled.div`
  position: relative;
  letter-spacing: 0.16px;
  line-height: 18px;
`;
const Typography = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-7xs);
  text-align: left;
  font-size: var(--components-button-small-size);
  color: var(--text-normal);
`;
const CancelfilledIcon = styled.img`
  position: relative;
  border-radius: var(--br-29xl);
  width: 16px;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
`;
const Container1 = styled.div`
  border-radius: var(--br-base);
  border: 1px solid var(--color-gray-100);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: var(--padding-10xs) var(--padding-9xs);
`;
const Chipoutlined = styled.div`
  border-radius: var(--br-81xl);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Typography1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-7xs);
  text-align: left;
  font-size: var(--components-button-small-size);
  color: var(--light-text-primary);
`;
const Chipoutlined1 = styled.div`
  border-radius: var(--br-81xl);
  display: none;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Autocompletetag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-5xs);
  z-index: 1;
  text-align: center;
  font-size: var(--components-helper-text-size);
`;
const Value3 = styled.div`
  flex: 1;
  position: relative;
  letter-spacing: 0.15px;
  line-height: 24px;
  font-weight: 600;
  color: var(--light-text-primary);
  display: none;
  z-index: 2;
`;
const Placeholder = styled.div`
  flex: 1;
  position: relative;
  letter-spacing: 0.15px;
  line-height: 24px;
  font-weight: 600;
  color: var(--light-text-disabled);
  display: none;
  z-index: 3;
`;
const ExpandmorefilledIcon = styled.img`
  position: absolute;
  margin: 0 !important;
  top: calc(50% - 20px);
  right: 0px;
  width: 24px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 4;
`;
const Autocompleteclose = styled.div`
  margin: 0 !important;
  position: absolute;
  top: calc(50% - 18px);
  right: 2px;
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 5;
`;
const Content11 = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  gap: var(--gap-5xs);
  font-size: var(--typography-body-1-size);
  color: var(--light-primary-contrast);
`;
const Input = styled.div`
  align-self: stretch;
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-4xs) var(--padding-xs) var(--padding-5xs);
  gap: var(--gap-10xs);
  z-index: 0;
`;
const UnderlineIcon = styled.img`
  position: absolute;
  margin: 0 !important;
  width: 100%;
  right: 0px;
  bottom: 0px;
  left: 0px;
  max-width: 100%;
  overflow: hidden;
  height: 1px;
  flex-shrink: 0;
  display: none;
  z-index: 1;
`;
const Content10 = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
`;
const Icon11 = styled.div`
  width: 16px;
  height: 16px;
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const HelperText = styled.div`
  align-self: stretch;
  flex: 1;
  position: relative;
  letter-spacing: 0.4px;
  line-height: 20px;
  display: flex;
  align-items: center;
`;
const Helpertext = styled.div`
  align-self: stretch;
  height: 20px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px 0px var(--padding-xs);
  box-sizing: border-box;
`;
const Selectfilled = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-10xs);
`;
const Autocomplete = styled.div`
  width: 394px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const CardParent = styled.div`
  width: 384px;
  height: 539px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-5xl);
`;
const InfooutlinedIcon = styled.img`
  position: relative;
  width: 35px;
  height: 35px;
  overflow: hidden;
  flex-shrink: 0;
`;
const NotReceivingTrip = styled.b`
  position: relative;
  line-height: 32px;
  display: inline-block;
  width: 342.11px;
`;
const LastUpdateReceived = styled.div`
  position: relative;
  font-size: var(--typography-body-1-size);
  letter-spacing: 0.15px;
  line-height: 150%;
  font-family: var(--typography-body-1);
  display: inline-block;
  width: 609px;
`;
const NotReceivingTripInformationParent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-9xs) 0px 0px;
  gap: var(--gap-5xs);
`;
const IconParent = styled.div`
  align-self: stretch;
  border-bottom: 1px solid var(--light-other-divider);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px var(--padding-5xl);
  gap: var(--gap-base);
`;
const VerifyDriverLocation = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  line-height: 24px;
  font-weight: 600;
  display: inline-block;
  width: 421.13px;
`;
const CheckMapTo = styled.div`
  position: absolute;
  top: 28px;
  left: 0px;
  font-size: var(--typography-body-1-size);
  letter-spacing: 0.15px;
  line-height: 150%;
  display: inline-block;
  width: 632px;
`;
const VerifyDriverLocationParent = styled.div`
  flex: 1;
  position: relative;
  height: 52px;
`;
const Base4 = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-xs) 41px;
  gap: var(--gap-5xs);
`;
const Buttoncontained2 = styled.div`
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-main);
  box-shadow: var(--elevation-2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: var(--components-button-large-size);
  color: var(--light-primary-contrast);
`;
const FrameChild = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
  flex-shrink: 0;
`;
const GroupParent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-5xs);
  font-size: var(--typography-h5-size);
  font-family: var(--typography-body-1);
`;
const List = styled.div`
  align-self: stretch;
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2-error);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-29xl) var(--padding-13xl) 40px var(--padding-29xl);
  gap: var(--gap-5xl);
`;
const Icon14 = styled.div`
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Button5 = styled.div`
  position: relative;
  letter-spacing: 0.4px;
  line-height: 24px;
  font-weight: 600;
`;
const Container5 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-4xs) var(--padding-base);
  gap: var(--gap-7xs);
  z-index: 0;
`;
const Line = styled.div`
  position: absolute;
  margin: 0 !important;
  width: calc(100% + 2px);
  right: -1px;
  bottom: -1px;
  left: -1px;
  border-top: 2px solid var(--light-primary-main);
  box-sizing: border-box;
  height: 2px;
  z-index: 1;
`;
const Tab = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px var(--padding-xl);
  position: relative;
  color: var(--light-primary-main);
`;
const Container6 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-4xs) var(--padding-base);
  gap: var(--gap-7xs);
`;
const Tab1 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px var(--padding-xl);
  color: var(--text-normal);
`;
const Tab3 = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const Tabs = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-base) 0px;
`;
const Autocompletetag2 = styled.div`
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-5xs);
  z-index: 0;
  text-align: center;
  font-size: var(--components-helper-text-size);
`;
const IdMessageType = styled.div`
  flex: 1;
  position: relative;
  letter-spacing: 0.15px;
  line-height: 24px;
  font-weight: 600;
  color: var(--light-text-secondary);
  z-index: 1;
`;
const Placeholder2 = styled.div`
  flex: 1;
  position: relative;
  letter-spacing: 0.15px;
  line-height: 24px;
  font-weight: 600;
  color: var(--light-text-disabled);
  display: none;
  z-index: 2;
`;
const SearchfilledIcon = styled.img`
  position: absolute;
  margin: 0 !important;
  top: calc(50% - 12px);
  right: 0px;
  width: 24px;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 3;
`;
const Autocompleteclose2 = styled.div`
  margin: 0 !important;
  position: absolute;
  top: calc(50% - 10px);
  right: 2px;
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 4;
`;
const Content14 = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  gap: var(--gap-5xs);
`;
const Input2 = styled.div`
  align-self: stretch;
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2);
  width: 279px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-xs);
  box-sizing: border-box;
`;
const Autocompletetag3 = styled.div`
  display: none;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-5xs);
  z-index: 1;
  text-align: center;
  font-size: var(--components-helper-text-size);
`;
const Value5 = styled.div`
  flex: 1;
  position: relative;
  letter-spacing: 0.15px;
  line-height: 24px;
  font-weight: 600;
  color: var(--light-text-primary);
  z-index: 2;
`;
const Input3 = styled.div`
  align-self: stretch;
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-7xs) var(--padding-xs) var(--padding-9xs);
  gap: var(--gap-11xs);
  z-index: 0;
`;
const Content15 = styled.div`
  align-self: stretch;
  border-radius: var(--br-9xs) var(--br-9xs) 0px 0px;
  background-color: var(--light-other-filled-input-background);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
`;
const Helpertext2 = styled.div`
  align-self: stretch;
  height: 20px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px 0px var(--padding-xs);
  box-sizing: border-box;
  color: var(--light-text-secondary);
`;
const Selectfilled2 = styled.div`
  width: 184px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-10xs);
  font-size: var(--components-helper-text-size);
  color: var(--light-text-primary);
`;
const Spacer4 = styled.div`
  position: absolute;
  height: 100%;
  top: 0px;
  bottom: 0px;
  left: calc(50% - 2px);
  width: 4px;
`;
const Frame4 = styled.div`
  flex: 1;
  position: relative;
  background-color: var(--color-gray-200);
  width: 4px;
`;
const Spacerhorizontal4 = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
const Base5 = styled.div`
  height: 48px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: var(--padding-xs) var(--padding-3xl);
  box-sizing: border-box;
  gap: var(--gap-5xs);
`;
const Buttonoutlined2 = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: var(--br-10xs) 0px 0px var(--br-10xs);
  background-color: var(--light-primary-contrast);
  border: 1px solid var(--light-primary-shades-50p);
  box-sizing: border-box;
  width: 96px;
  height: 48px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: var(--padding-5xs) 0px 0px;
`;
const MaskedIcon12 = styled.img`
  position: relative;
  width: 18px;
  height: 18px;
`;
const Button12 = styled.div`
  position: relative;
  letter-spacing: 0.46px;
  line-height: 24px;
  font-weight: 600;
  display: none;
`;
const MaskedIcon13 = styled.img`
  position: relative;
  width: 16px;
  height: 18px;
  display: none;
`;
const Base6 = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding: 0px var(--padding-xs);
  gap: var(--gap-5xs);
`;
const Buttonoutlined3 = styled.div`
  position: absolute;
  top: 0px;
  left: 92.28px;
  border-radius: 0px var(--br-10xs) var(--br-10xs) 0px;
  border-top: 1px solid var(--light-primary-shades-50p);
  border-right: 1px solid var(--light-primary-shades-50p);
  border-bottom: 1px solid var(--light-primary-shades-50p);
  box-sizing: border-box;
  width: 46.72px;
  height: 48px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: var(--components-button-small-size);
`;
const ButtonoutlinedParent = styled.div`
  position: relative;
  width: 139px;
  height: 48px;
  font-size: var(--components-button-large-size);
  color: var(--light-primary-main);
`;
const InputParent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px var(--padding-5xs);
  gap: var(--gap-smi);
  font-size: var(--typography-body-1-size);
  color: var(--light-primary-contrast);
`;
const Container16 = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: var(--padding-sm) var(--padding-3xs);
`;
const Datagridelementscell = styled.div`
  align-self: stretch;
  width: 161px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const AvatarImageIcon = styled.img`
  position: relative;
  width: 40px;
  height: 40px;
  z-index: 0;
`;
const Badge9 = styled.div`
  position: absolute;
  height: 66.67%;
  width: 66.67%;
  top: 16.67%;
  right: 16.67%;
  bottom: 16.66%;
  left: 16.67%;
  border-radius: var(--br-5xs);
  background-color: var(--light-success-main);
  overflow: hidden;
`;
const Border8 = styled.div`
  position: absolute;
  margin: 0 !important;
  right: -2px;
  bottom: -2px;
  border-radius: var(--br-45xl);
  background-color: var(--light-primary-contrast);
  width: 12px;
  height: 12px;
  display: none;
  z-index: 1;
`;
const Avatar8 = styled.div`
  background-color: var(--color-gray-200);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
const Typography12 = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--molina-main);
`;
const MonitoringList = styled.span`
  color: var(--light-text-primary);
`;
const Typography13 = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--light-text-secondary);
`;
const Typography14 = styled.div`
  position: relative;
  font-size: var(--components-helper-text-size);
  letter-spacing: 0.4px;
  line-height: 166%;
  color: var(--light-text-secondary);
`;
const FrameGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-base);
`;
const Typography15 = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  display: inline-block;
  width: 377px;
  color: var(--light-text-secondary);
`;
const Container17 = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: var(--padding-sm) var(--padding-3xs);
  gap: var(--gap-5xs);
`;
const Container15 = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const Datagridelementscell2 = styled.div`
  align-self: stretch;
  width: 101px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const TrRowCellUpcomingTrips = styled.div`
  align-self: stretch;
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const Avatar10 = styled.div`
  border-radius: var(--br-45xl);
  background-color: var(--light-info-shades-4p);
  width: 40px;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--padding-5xs);
  box-sizing: border-box;
  z-index: 0;
`;
const A1Transportation = styled.span`
  color: var(--molina-main);
`;
const Typography24 = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  display: inline-block;
  width: 502.54px;
  color: var(--light-text-secondary);
`;
const Typography40 = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--light-text-primary);
`;
const Typography42 = styled.div`
  position: relative;
  letter-spacing: 0.17px;
  line-height: 143%;
  color: var(--light-text-secondary);
  display: inline-block;
  width: 377px;
`;
const Datagridelementscell10 = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: var(--molina-main);
`;
const Op8 = styled.div`
  align-self: stretch;
  flex: 1;
  position: relative;
  letter-spacing: 0.14px;
  line-height: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Avatar15 = styled.div`
  border-radius: var(--br-45xl);
  background-color: var(--light-info-shades-4p);
  width: 40px;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 0;
`;
const Typography47 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  font-size: var(--typography-subtitle-2-size);
  color: var(--light-text-primary);
`;
const Datagridelementscell13 = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  font-size: var(--components-avatar-initials-size);
  color: var(--light-info-main);
`;
const TrRowCellUpcomingTripsParent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-9xs);
  color: var(--light-text-primary);
`;
const PageIcon = styled.img`
  position: relative;
  width: 16px;
  height: 16px;
`;
const Tableelementstablefooter = styled.div`
  align-self: stretch;
  height: 16px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px 0px var(--padding-xs);
  box-sizing: border-box;
  color: var(--light-primary-main);
`;
const ListActivity = styled.div`
  align-self: stretch;
  border-radius: var(--br-10xs);
  background-color: var(--light-primary-contrast);
  box-shadow: var(--elevation-2);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-base) var(--padding-13xl) var(--padding-5xl);
  gap: var(--gap-smi);
  font-size: var(--typography-subtitle-2-size);
  color: var(--light-text-secondary);
  font-family: var(--typography-body-1);
`;
const ListParent = styled.div`
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-5xl);
  font-size: var(--typography-h3-size);
  color: var(--light-text-primary);
  font-family: var(--typography-h3);
`;
const FrameParent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-5xl);
`;
const ContainerFluid = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-5xs) var(--padding-5xl) var(--padding-5xl);
`;
const ContainerFluidWrapper = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 3;
  font-size: var(--components-helper-text-size);
`;
const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
  z-index: 1;
`;
const GreyBandParent = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
`;
const PassengerDetail = styled.div`
  background-color: var(--light-primary-contrast);
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 1;
`;
const Exception1Root = styled.div`
  position: relative;
  background-color: var(--light-primary-contrast);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  font-size: var(--typography-subtitle-2-size);
  color: var(--light-text-secondary);
  font-family: var(--typography-body-1);
`;

const Exception1: FunctionComponent = () => {
  const [selectedValue, setSelectedValue] = useState('');
  const [isVisible, setIsVisible] = useState(true);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedValue(event.target.value as string);
  };

  const [counter, setCounter] = useState(1);

  const handleNextClick = () => {
    setCounter(counter + 1);
  };

  return (
    <Exception1Root>
      <PassengerDetail>
        <GreyBandParent>
          <GreyBand>
            <GreyBandChild />
          </GreyBand>
          <Wrapper>
            <PageHeaderWRightActions>
              <HeaderArea>
                <LeftSide>
                  <TitleBreadcrumbs />
                  <ButtoncontainedParent>
                    <Button onClick={() => setIsVisible(!isVisible)}>
                      <Buttoncontained>
                        <Base>
                          <MaskedIcon alt="" src="/masked-icon.svg" />
                          <Button11>Medium</Button11>
                        </Base>
                      </Buttoncontained>
                    </Button>
                    <Monitoring5Parent>
                      <Monitoring5>
                        <Monitoring>{`Monitoring `}</Monitoring>
                        <Span>({counter})</Span>
                      </Monitoring5>
                      <Badge>
                        <Text1>({counter})</Text1>
                      </Badge>
                    </Monitoring5Parent>
                  </ButtoncontainedParent>
                </LeftSide>
                <Spacerhorizontal>
                  <Frame>
                    <Spacer />
                  </Frame>
                </Spacerhorizontal>
                <Spacerhorizontal>
                  <Frame>
                    <Spacer />
                  </Frame>
                </Spacerhorizontal>
                <Button onClick={handleNextClick}>
                  <Buttonoutlined>
                    <Base1>
                      Next
                      <CallIcon alt="" src="/masked-icon2.svg" />
                    </Base1>
                  </Buttonoutlined>
                </Button>
              </HeaderArea>
            </PageHeaderWRightActions>
            {/* <TripLegMonitoringSection /> */}
            {isVisible && (
              <>
                <PageHeaderWRightActions1>
                  <HeaderAreaParent>
                    <HeaderArea1>
                      <TitleBreadcrumbs1>
                        <WrapperParent>
                          <Wrapper1>
                            <VectorIcon alt="" src="/vector.svg" />
                          </Wrapper1>
                          <EmmaTaylor>Emma Taylor</EmmaTaylor>
                        </WrapperParent>
                        <Text11>
                          Passenger since 2020 - 13 trips this month - 2
                          Scheduled
                        </Text11>
                      </TitleBreadcrumbs1>
                      <Spacerhorizontal>
                        <Frame>
                          <Spacer />
                        </Frame>
                      </Spacerhorizontal>
                      <Spacerhorizontal>
                        <Frame>
                          <Spacer />
                        </Frame>
                      </Spacerhorizontal>
                    </HeaderArea1>
                    <InstanceParent>
                      <BaseStepElementsParent>
                        <BaseStepElements>
                          <ChevronleftoutlinedIcon
                            alt=""
                            src="/masked-icon1.svg"
                          />
                        </BaseStepElements>
                        <Back>Reservation 123456</Back>
                      </BaseStepElementsParent>
                      {/* <FormControl fullWidth>
                    <InputLabel>
                      <Buttoncontained1>
                        <Base2>
                          <MaskedIcon2 alt="" src="/masked-icon1.svg" />
                          <Button1>
                            <Leg1Of>Leg 1 of 2</Leg1Of>
                            <Active> (active)</Active>
                          </Button1>
                          <CallIcon alt="" src="/masked-icon3.svg" />
                        </Base2>
                      </Buttoncontained1>
                    </InputLabel>
                    <Select value={selectedValue} label="Option">
                      <MenuItem value="1">Trip Leg 1</MenuItem>
                      <MenuItem value="2">Trip Leg 2</MenuItem>
                    </Select>
                  </FormControl> */}
                      <ButtoncontainedGroup>
                        <Buttoncontained1>
                          <Base2>
                            <MaskedIcon2 alt="" src="/masked-icon1.svg" />
                            <Button1>
                              <Leg1Of>Leg 1 of 2</Leg1Of>
                              <Active> (active)</Active>
                            </Button1>
                            <CallIcon alt="" src="/masked-icon3.svg" />
                          </Base2>
                        </Buttoncontained1>
                        <Buttonoutlined1>
                          <MaskedIcon2 alt="" src="/masked-icon1.svg" />
                          <Button>Edit</Button>
                          <MaskedIcon2 alt="" src="/masked-icon1.svg" />
                        </Buttonoutlined1>
                        <Iconbutton>
                          <Container>
                            <ChevronleftoutlinedIcon
                              alt=""
                              src="/morevertoutlined.svg"
                            />
                          </Container>
                        </Iconbutton>
                      </ButtoncontainedGroup>
                    </InstanceParent>
                  </HeaderAreaParent>
                </PageHeaderWRightActions1>
                {/* <Icon>
              <StaroutlinefilledIcon alt="" src="/masked-icon1.svg" />
            </Icon> */}
                <ContainerFluidWrapper>
                  <ContainerFluid>
                    <FrameParent>
                      <CardParent>
                        <Card>
                          <Cardelementscardmedia>
                            <PlaceholderimageIcon
                              alt=""
                              src="/masked-icon1.svg"
                            />
                          </Cardelementscardmedia>
                          <Cardelementscardheader>
                            <Content>
                              <Content1>
                                <Status1>Status</Status1>
                                <InTransit>In-Transit</InTransit>
                              </Content1>
                              <Content2>
                                <Status1>Pickup</Status1>
                                <Am>
                                  <Span1>{`9:30 `}</Span1>
                                  <Am1>AM</Am1>
                                </Am>
                              </Content2>
                              <Content3>
                                <Status1>ETA</Status1>
                                <Am2>
                                  <Span1>{`9:30 `}</Span1>
                                  <Am1>AM</Am1>
                                </Am2>
                              </Content3>
                              <Subheader>Subheader</Subheader>
                            </Content>
                          </Cardelementscardheader>
                          <Dividerhorizontal />
                          <Cardelementscardcontent>
                            <StepperParent>
                              <Stepper>
                                <Step>
                                  <ChevronleftoutlinedIcon
                                    alt=""
                                    src="/base-step-elements.svg"
                                  />
                                  <Iconbutton>
                                    <Created>Created</Created>
                                    <Details>Details</Details>
                                  </Iconbutton>
                                </Step>
                                <Mask>
                                  <Connector />
                                </Mask>
                                <Step>
                                  <ChevronleftoutlinedIcon
                                    alt=""
                                    src="/base-step-elements1.svg"
                                  />
                                  <Iconbutton>
                                    <Created>Assigned</Created>
                                    <Details>Details</Details>
                                  </Iconbutton>
                                </Step>
                                <Mask>
                                  <Connector />
                                </Mask>
                                <Step>
                                  <ChevronleftoutlinedIcon
                                    alt=""
                                    src="/base-step-elements2.svg"
                                  />
                                  <Iconbutton>
                                    <Created>In-Transit</Created>
                                  </Iconbutton>
                                </Step>
                                <Mask2>
                                  <Connector2 />
                                  <MaskChild />
                                </Mask2>
                                <Step3>
                                  <BaseStepElements4>
                                    <Value>4</Value>
                                  </BaseStepElements4>
                                  <Content7>
                                    <Onsite>Onsite</Onsite>
                                    <Details2>Details</Details2>
                                  </Content7>
                                </Step3>
                                <Mask3>
                                  <Connector3 />
                                </Mask3>
                                <Step3>
                                  <BaseStepElements4>
                                    <Value>5</Value>
                                  </BaseStepElements4>
                                  <Content7>
                                    <Onsite>Pick Up</Onsite>
                                    <Optional>Optional</Optional>
                                  </Content7>
                                </Step3>
                                <Mask>
                                  <Connector3 />
                                </Mask>
                                <Step3>
                                  <BaseStepElements4>
                                    <Value>6</Value>
                                  </BaseStepElements4>
                                  <Content7>
                                    <Onsite>Complete</Onsite>
                                    <Optional1>Optional</Optional1>
                                  </Content7>
                                </Step3>
                              </Stepper>
                              <StepParent>
                                <Step6>
                                  <EmmaTaylorParent>
                                    <Created>Emma Taylor</Created>
                                    <AmAmbd2d>
                                      <Ambd2d>07/04/2023 8:34AM</Ambd2d>
                                      <Ambd2d>AMBD2D</Ambd2d>
                                    </AmAmbd2d>
                                  </EmmaTaylorParent>
                                  <IconWrapper>
                                    <TypographyParent>
                                      <ChevronleftoutlinedIcon
                                        alt=""
                                        src="/chatbubbleoutlinerounded.svg"
                                      />
                                    </TypographyParent>
                                  </IconWrapper>
                                  <IconWrapper>
                                    <TypographyParent>
                                      <CallIcon alt="" src="/call.svg" />
                                    </TypographyParent>
                                  </IconWrapper>
                                </Step6>
                                <Step7>
                                  <EmmaTaylorParent>
                                    <Created>A1 Transporting</Created>
                                    <PmMikeDriverContainer>
                                      <Ambd2d>07/04/2023 2:00PM</Ambd2d>
                                      <Ambd2d>
                                        Mike Driver - Hyundai Elentra (CEP 121)
                                      </Ambd2d>
                                    </PmMikeDriverContainer>
                                  </EmmaTaylorParent>
                                </Step7>
                                <Step8>
                                  <AmParent>
                                    <Created>07/06/2023 9:30AM</Created>
                                    <HarrietLaneSouthBoulderContainer>
                                      <Ambd2d>1928 Harriet Lane South</Ambd2d>
                                      <Ambd2d>Boulder, LA, 82251</Ambd2d>
                                    </HarrietLaneSouthBoulderContainer>
                                  </AmParent>
                                </Step8>
                                <Step9>
                                  <EmmaTaylorParent>
                                    <Created>07/06/2023 9:20AM</Created>
                                    <DriverUpdatedTrip>
                                      Driver updated trip status in app
                                    </DriverUpdatedTrip>
                                  </EmmaTaylorParent>
                                  <IconWrapper>
                                    <TypographyParent>
                                      <ChevronleftoutlinedIcon
                                        alt=""
                                        src="/masked-icon1.svg"
                                      />
                                    </TypographyParent>
                                  </IconWrapper>
                                  <IconWrapper>
                                    <TypographyParent>
                                      <CallIcon
                                        alt=""
                                        src="/masked-icon1.svg"
                                      />
                                    </TypographyParent>
                                  </IconWrapper>
                                </Step9>
                                <Step10>
                                  <EmmaTaylorParent>
                                    <EmmaTaylor2>Emma Taylor</EmmaTaylor2>
                                    <HarrietLaneSouthBoulderContainer1>
                                      <Ambd2d>1700 July Lane South</Ambd2d>
                                      <Ambd2d>Boulder, LA, 64251</Ambd2d>
                                    </HarrietLaneSouthBoulderContainer1>
                                  </EmmaTaylorParent>
                                </Step10>
                              </StepParent>
                            </StepperParent>
                          </Cardelementscardcontent>
                        </Card>
                        <Autocomplete>
                          <Selectfilled>
                            <Content10>
                              <Input>
                                <Label>Reservation Notes</Label>
                                <Content11>
                                  <AdornStartContainer>
                                    <Adornmentstart>
                                      <CallIcon
                                        alt=""
                                        src="/masked-icon1.svg"
                                      />
                                    </Adornmentstart>
                                  </AdornStartContainer>
                                  <Autocompletetag>
                                    <Chipoutlined>
                                      <Container1>
                                        <AvatarMessagesfalse24pxc>
                                          <Avatar>
                                            <Value>OP</Value>
                                          </Avatar>
                                          <Border>
                                            <Badge1 />
                                          </Border>
                                        </AvatarMessagesfalse24pxc>
                                        <Typography>
                                          <Chip>Security code: 11234</Chip>
                                        </Typography>
                                        <CancelfilledIcon
                                          alt=""
                                          src="/cancelfilled.svg"
                                        />
                                      </Container1>
                                    </Chipoutlined>
                                    <Chipoutlined1>
                                      <Container1>
                                        <AvatarMessagesfalse24pxc>
                                          <Avatar>
                                            <Value>OP</Value>
                                          </Avatar>
                                          <Border>
                                            <Badge1 />
                                          </Border>
                                        </AvatarMessagesfalse24pxc>
                                        <Typography1>
                                          <Chip>Chip</Chip>
                                        </Typography1>
                                        <CancelfilledIcon
                                          alt=""
                                          src="/masked-icon1.svg"
                                        />
                                      </Container1>
                                    </Chipoutlined1>
                                  </Autocompletetag>
                                  <Value3>Value</Value3>
                                  <Placeholder>Placeholder</Placeholder>
                                  <ExpandmorefilledIcon
                                    alt=""
                                    src="/expandmorefilled.svg"
                                  />
                                  <Autocompleteclose>
                                    <StaroutlinefilledIcon
                                      alt=""
                                      src="/masked-icon1.svg"
                                    />
                                  </Autocompleteclose>
                                </Content11>
                              </Input>
                              <UnderlineIcon alt="" src="/masked-icon1.svg" />
                            </Content10>
                            <Helpertext>
                              <Icon11>
                                <PlaceholderimageIcon
                                  alt=""
                                  src="/masked-icon1.svg"
                                />
                              </Icon11>
                              <HelperText>Helper text</HelperText>
                            </Helpertext>
                          </Selectfilled>
                        </Autocomplete>
                        <Autocomplete>
                          <Selectfilled>
                            <Content10>
                              <Input>
                                <Label>Passengerr notes</Label>
                                <Content11>
                                  <AdornStartContainer>
                                    <Adornmentstart>
                                      <CallIcon
                                        alt=""
                                        src="/masked-icon1.svg"
                                      />
                                    </Adornmentstart>
                                  </AdornStartContainer>
                                  <Autocompletetag>
                                    <Chipoutlined>
                                      <Container1>
                                        <AvatarMessagesfalse24pxc>
                                          <Avatar>
                                            <Value>OP</Value>
                                          </Avatar>
                                          <Border>
                                            <Badge1 />
                                          </Border>
                                        </AvatarMessagesfalse24pxc>
                                        <Typography>
                                          <Chip>Passenger uses walker</Chip>
                                        </Typography>
                                        <CancelfilledIcon
                                          alt=""
                                          src="/cancelfilled.svg"
                                        />
                                      </Container1>
                                    </Chipoutlined>
                                    <Chipoutlined1>
                                      <Container1>
                                        <AvatarMessagesfalse24pxc>
                                          <Avatar>
                                            <Value>OP</Value>
                                          </Avatar>
                                          <Border>
                                            <Badge1 />
                                          </Border>
                                        </AvatarMessagesfalse24pxc>
                                        <Typography1>
                                          <Chip>Chip</Chip>
                                        </Typography1>
                                        <CancelfilledIcon
                                          alt=""
                                          src="/masked-icon1.svg"
                                        />
                                      </Container1>
                                    </Chipoutlined1>
                                  </Autocompletetag>
                                  <Value3>Value</Value3>
                                  <Placeholder>Placeholder</Placeholder>
                                  <ExpandmorefilledIcon
                                    alt=""
                                    src="/expandmorefilled.svg"
                                  />
                                  <Autocompleteclose>
                                    <StaroutlinefilledIcon
                                      alt=""
                                      src="/masked-icon1.svg"
                                    />
                                  </Autocompleteclose>
                                </Content11>
                              </Input>
                              <UnderlineIcon alt="" src="/masked-icon1.svg" />
                            </Content10>
                            <Helpertext>
                              <Icon11>
                                <PlaceholderimageIcon
                                  alt=""
                                  src="/masked-icon1.svg"
                                />
                              </Icon11>
                              <HelperText>Helper text</HelperText>
                            </Helpertext>
                          </Selectfilled>
                          <Spacerhorizontal>
                            <Frame>
                              <Spacer />
                            </Frame>
                          </Spacerhorizontal>
                          <Spacerhorizontal>
                            <Frame>
                              <Spacer />
                            </Frame>
                          </Spacerhorizontal>
                        </Autocomplete>
                      </CardParent>
                      <ListParent>
                        <TripActivitiesMapMessages />
                      </ListParent>
                    </FrameParent>
                  </ContainerFluid>
                </ContainerFluidWrapper>
              </>
            )}
          </Wrapper>
        </GreyBandParent>
      </PassengerDetail>
    </Exception1Root>
  );
};

export default Exception1;
